import { axiosInstance } from "../../utils";

const actions = {
    FETCH_PRODUCT_GROUPS_REQUESTED: 'FETCH_PRODUCT_GROUPS_REQUESTED',
    FETCH_PRODUCT_GROUPS_SUCCEEDED: 'FETCH_PRODUCT_GROUPS_SUCCEEDED',
    FETCH_PRODUCT_GROUPS_FAILED: 'FETCH_PRODUCT_GROUPS_FAILED',

    FETCH_PRODUCT_GROUP_REQUESTED: 'FETCH_PRODUCT_GROUP_REQUESTED',
    FETCH_PRODUCT_GROUP_SUCCEEDED: 'FETCH_PRODUCT_GROUP_SUCCEEDED',
    FETCH_PRODUCT_GROUP_FAILED: 'FETCH_PRODUCT_GROUP_FAILED',

    DELETE_PRODUCT_GROUP_REQUESTED: 'DELETE_PRODUCT_GROUP_REQUESTED',
    DELETE_PRODUCT_GROUP_SUCCEEDED: 'DELETE_PRODUCT_GROUP_SUCCEEDED',
    DELETE_PRODUCT_GROUP_FAILED: 'DELETE_PRODUCT_GROUP_FAILED',

    removeProductGroup: (id = undefined) => {
        return {
            type: actions.DELETE_PRODUCT_GROUP_REQUESTED,
            payload: id
        }
    },

    deleteProductGroup: async (id = undefined) => {
        const url = `items_groups/`+id;

        try {
            const response = await axiosInstance.delete(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    fetchProductGroups: (params = undefined) => {
        return {
            type: actions.FETCH_PRODUCT_GROUPS_REQUESTED,
            payload: params
        }
    },

    fetchProductGroup: (id = undefined) => {
        return {
            type: actions.FETCH_PRODUCT_GROUP_REQUESTED,
            payload: id
        }
    },

    getProductGroups: async (params = undefined) => {
        const url = `items_groups`;

        try {
            const productGroups = await axiosInstance.get(url,{ params });
            return productGroups?.data;
        } catch (error) {
            throw error;
        }
    },

    getProductGroup: async (id = undefined) => {
        const url = `items_groups/` + id;

        try {
            const productGroup = await axiosInstance.get(url);
            return productGroup.data;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
